document.addEventListener("DOMContentLoaded", function () {

    //-------------------------------//
    //       MENU LANGUES
    //-------------------------------//

    const langueActive = document.getElementById("langue-active");
    const menuLangues = document.getElementById("menu-langues");
    if (langueActive) {
        langueActive.onclick = function (e) {
            e.preventDefault();
            if (menuLangues.style.display === "none") {
                menuLangues.style.display = "block";
            } else {
                menuLangues.style.display = "none";
            }
        }
    }


    /*=============================================>>>>>
    = Fixed menu =
    ===============================================>>>>>*/
    function fixedMenu() {
        let navbar = document.querySelector("#wrapper-navbar");
        let sticky = navbar.offsetHeight / 1.5;

        if (window.pageYOffset >= sticky) {
            navbar.classList.add("fixed-top");
        } else {
            navbar.classList.remove("fixed-top");
        }
    }

    menuDevelop();

    // const burgerMenu = document.querySelector(".navbar-toggler");
    // const mainMenu = document.querySelector("#navbarNavDropdown");
    // if (burgerMenu) {
    //     burgerMenu.onclick = function (e) {
    //         e.preventDefault();
    //         e.stopPropagation();
    //         if (mainMenu.classList.contains("show")) {
    //             mainMenu.classList.remove("show");
    //         } else {
    //             mainMenu.classList.add("show");
    //         }
    //     }
    // }
    // window.onclick = function (event) {
    //     if (!event.target.matches(".navbar-toggler")) {
    //         if (mainMenu.classList.contains("show")) {
    //             mainMenu.classList.remove("show");
    //         }
    //     }
    // };


    // SCROLL EVENTS
    window.onscroll = function () {
        fixedMenu();
    };



    //--------------------//
    //       COOKIES
    //--------------------//
    let cookies = document.querySelector(".cookies");
    if (cookies) {
        cookies.addEventListener("click", function (e) {
            e.preventDefault();
            if (tarteaucitron) {
                tarteaucitron.userInterface.openPanel();
            }
        });
    }



// ACCORDEON
    let acc = document.getElementsByClassName("accordion");
    let i;

    if (acc) {
        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                let panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }

    //  CHIFFRES ANIMES
    jQuery(window).scroll(chiffresScroll);
    let viewed = false;

    function isScrolledIntoView(elem) {
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height();

        if (jQuery(elem).offset() != undefined) {
            var elemTop = jQuery(elem).offset().top;
        }
        var elemBottom = elemTop + jQuery(elem).height();

        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }
    function chiffresScroll() {
        if (isScrolledIntoView(jQuery(".vignettes")) && !viewed) {
            viewed = true;
            (jQuery(".chiffres-cles__number")).each(function () {
                console.log( jQuery(this));
                jQuery(this)
                    .prop("Counter", 0)
                    .animate(
                        {
                            Counter: jQuery(this).text().replace(" ", ""),
                        },
                        {
                            duration: 4000,
                            easing: "swing",
                            step: function (now) {
                                jQuery(this).text(Math.ceil(now).toLocaleString());
                            },
                        }
                    );
            });
        }
    }



    /*
    CARTE INTERACTIVE
    */
    // jQuery(".carte_list_item").click(function()  {
    //     jQuery(".carte_list_item").removeClass("active");
    //     jQuery(this).addClass("active");
    //     jQuery('.carte_affichee').removeClass("carte_visible");
    //     jQuery('#'+jQuery(this).data('carte')).addClass("carte_visible");
    // });



    //RGPD SARBACANE
    let sarbacane = jQuery(".widget form input");
    if (sarbacane) {
        sarbacane.focus(function () {
            var rgpd = jQuery(".widget form p:nth-of-type(2)");
            rgpd.addClass("d-block");
        });
        sarbacane.focusout(function () {
            var rgpd = jQuery(".widget form p:nth-of-type(2)");
            rgpd.removeClass("d-block");
        });
    }

    // document.querySelector('.wpcf7-submit').onclick = function (e) {
    //    // e.preventDefault();
    //    // e.stopPropagation();
    //    let rgpd = document.querySelector('.rgpd');
    //    if (rgpd.classList.contains("d-none")){
    //       rgpd.classList.remove("d-none");
    //    } else {
    //       rgpd.classList.add("d-none");
    //    }
    // }


    /**
     * Slider Témoignages
     */
    var sliderTemoign = document.querySelectorAll(".carousel-temoignages");
    const sliderTemoignages = document.querySelector('#slider-temoignages');
    if (sliderTemoignages) {
        const flktysliderTemoignages = new Flickity(sliderTemoignages, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": true,
            "cellAlign": "center",
            "prevNextButtons": true,
            // "autoPlay": true,
            "autoPlay": 6000,
            "pauseAutoPlayOnHover": false,
            "adaptiveHeight": true
        });


        let sliderButtonNext = document.querySelector('.slider-button-next');
        let flickityButtonNext = document.querySelector('.flickity-button.flickity-prev-next-button.next');
        let sliderButtonPrev = document.querySelector('.slider-button-prev');
        let flickityButtonPrev = document.querySelector('.flickity-button.flickity-prev-next-button.previous');

        if (sliderButtonNext && flickityButtonNext) {
            sliderButtonNext.addEventListener('click', function () {
                flickityButtonNext.click();
            });
        }

        if (sliderButtonPrev && flickityButtonPrev) {
            sliderButtonPrev.addEventListener('click', function () {
                flickityButtonPrev.click();
            });
        }
    }

    //FIN DOM READY
});


function menuDevelop () {

    //Pour fermer les sous-menus ouverts
    const body = document.querySelector("body");
    body.addEventListener("click", function(event) {
        const isDropdownItem = event.target.classList.contains("dropdown-item") || event.target.closest(".dropdown-item");
        if (!isDropdownItem) {
            const shownDropdowns = document.querySelectorAll(".dropdown-menu .show, .dropdown-submenu .show");
            shownDropdowns.forEach(dropdown => dropdown.classList.remove("show"));
        }
    });

    //Pour gérer les sous-menus
    const dropdownItems = document.querySelectorAll(".menu-item-has-children > .dropdown-item");
    dropdownItems.forEach(item => {
        item.addEventListener("click", function(event) {
            event.preventDefault();
            event.stopPropagation();

            const isDropdownShown = this.nextElementSibling.classList.contains("show");
            const parentDropdownMenu = this.closest(".dropdown-menu");

            if (!isDropdownShown) {
                const shownDropdown = parentDropdownMenu.querySelector(".show");
                if (shownDropdown) {
                    const childDropdowns = shownDropdown.querySelectorAll(".dropdown-menu .show");
                    childDropdowns.forEach(child => child.classList.remove("show"));
                    shownDropdown.classList.remove("show");
                }
            }

            this.nextElementSibling.classList.toggle("show");

            const parentDropdown = this.closest("li.nav-item.dropdown.show");
            if (parentDropdown) {
                parentDropdown.addEventListener("hidden.bs.dropdown", function(event) {
                    const shownDropdowns = document.querySelectorAll(".dropdown-menu .show, .dropdown-submenu .show");
                    shownDropdowns.forEach(dropdown => dropdown.classList.remove("show"));
                });
            }
        });
    });

    // Ajouter la fonction pour fermer #navbarNavDropdown
    function closeNavbarNavDropdown(event) {
        const navbarNavDropdown = document.querySelector("#navbarNavDropdown");
        const isClickInsideNavbar = navbarNavDropdown.contains(event.target);

        if (!isClickInsideNavbar) {
            // Fermer le #navbarNavDropdown
            navbarNavDropdown.classList.remove("show");
        }
    }

    // Ajouter un écouteur d'événements au document
    document.addEventListener("click", closeNavbarNavDropdown);
}
